export default "__VITE_ASSET__wK3lkFA8__"